import React from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import LeftPanel from "./include/LeftPanel";
import { ToastContainer } from '../components/ui/toast';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { WalletContent } from "./CustomerWallet";
import { CreditContent } from "./CustomerCredit";
import { Wallet, ShieldCheck } from "lucide-react";

/**
 * /Finance — consolidated Finance hub (Wallet + Credit Score) using
 * the shadcn-style Tabs component, replacing two sidebar items.
 */
function FinancePage() {
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <h2 className="px-pagehead__title mb-4">Finance</h2>
                    <Tabs defaultValue="wallet">
                        <TabsList>
                            <TabsTrigger value="wallet"><Wallet size={15} /> My Wallet</TabsTrigger>
                            <TabsTrigger value="credit"><ShieldCheck size={15} /> Credit Line</TabsTrigger>
                        </TabsList>
                        <TabsContent value="wallet">
                            <WalletContent />
                        </TabsContent>
                        <TabsContent value="credit">
                            <CreditContent />
                        </TabsContent>
                    </Tabs>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default FinancePage;
